import React from 'react';
import { StatusIcon } from './StatusIcon';
import type { TramiteSummaryStats } from './types';
import type { SubtramiteEstado } from '@/subtramites/types';

interface StatsGridProps {
  stats: TramiteSummaryStats;
  hideStats?: SubtramiteEstado[];
}

export const StatsGrid: React.FC<StatsGridProps> = ({ stats, hideStats }) => {
  const statsItems = [
    {
      status: 'finalizado',
      value: stats.finalizado,
      label: 'Finalizados',
      bgColor: 'bg-green-50',
      textColor: 'text-green-800',
      labelColor: 'text-green-600'
    },
    {
      status: 'en-proceso',
      value: stats['en-proceso'],
      label: 'En Proceso',
      bgColor: 'bg-orange-100',
      textColor: 'text-orange-800',
      labelColor: 'text-orange-600'
    },
    {
      status: 'pendiente',
      value: stats.pendiente,
      label: 'Sin Iniciar',
      bgColor: 'bg-gray-100',
      textColor: 'text-gray-800',
      labelColor: 'text-gray-600'
    }
  ];

  return (
    <div className="grid grid-cols-3 gap-2 mb-4">
      {statsItems
        .filter(item => !hideStats || !hideStats.includes(item.status as SubtramiteEstado))
        .map(({ status, value, label, bgColor, textColor, labelColor }) => (
          <div key={status} className={`${bgColor} rounded-md p-2 text-center`}>
            <div className="flex items-center justify-center mb-1">
              <StatusIcon status={status as SubtramiteEstado} />
            </div>
            <div className={`text-sm font-semibold ${textColor}`}>{value}</div>
            <div className={`text-xs ${labelColor}`}>{label}</div>
          </div>
        ))}
    </div>
  );
};
